import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const OutpatientBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-blue-900 text-white">
      {t('component:badge.outpatient')}
    </Badge>
  );
};
